import React, { useState, useEffect } from 'react';
import {HtmlParse} from 'utils';
import StorageService from 'services/StorageService';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

const Tooltip = (props) => {
    const [show, setShow] = useState(false);
    const timer = props.timer;
    const once = props.once;
    let defaultView = props.defaultView;
    
    useEffect(() => {
        if(once && !defaultView) {
            let reported = StorageService.getValidationStorage(props.type);
            
            if(!reported){
                setShow(true);

                setTimeout(() => {
                    setShow(false);
                    StorageService.updateValidationStorage(props.type);
                }, timer);
            }
        }
    }, []);

    useEffect(() => {
        if(defaultView) {
            setShow(defaultView.show);
        }
    }, [defaultView]);
    
    const clickBtn = (event) => {
        setShow(false);
        event.preventDefault();
        StorageService.updateValidationStorage(props.type);
    }
    const mouseEnter = () => {
        if(!props.once){
            setShow(true)
        }
    }
    const mouseLeave = () => {
        if(!props.once){
            setShow(false)
        }
    }

    return(
        <div className={'tooltip-wrapper' + (!once ? ' hover' : '')}  onMouseEnter={mouseEnter}  onMouseLeave={mouseLeave}>
            {props.children && (typeof props.children === 'function' ? props.children(once && show) : props.children)}
            <div className={'tooltip-content' + ((once && show) ? ' visible' : '') }>
                <span className='tooltip-message'>{props.message ? HtmlParse(props.message) : ''}</span>
                {props.button && <button className={'new-modal-close jumbo-icon-new-close'}  onClick={clickBtn} />}
            </div>
        </div>
    )
}

Tooltip.propTypes = {
    timer: PropTypes.number,
    once: PropTypes.bool,
    children: PropTypes.any,
    type: PropTypes.string,
    message: PropTypes.string,
    button: PropTypes.string
}

export default Tooltip;
